module.exports = __webpack_public_path__ + "static/media/asb.af981ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asb.png
// module id = 493
// module chunks = 0